import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

import { faTrashAlt, faCaretLeft, faCaretRight, faCheckCircle } from '@fortawesome/free-solid-svg-icons'

import { OrderService } from '../order.service'

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnInit {
  @Input() part: any
  @Input() customer: any
  @Input() count: number
  @Output() countChange = new EventEmitter()

  products = []

  model = <any>{}

  error = false
  loading = false
  trash = faTrashAlt
  next = faCaretRight
  check = faCheckCircle
  previous = faCaretLeft
  view = 'cart'

  constructor(public order: OrderService) { }

  ngOnInit() {
    const items = localStorage.getItem('cart')
    this.products = items ? JSON.parse(items) : []
console.log('-- cart init --')
console.log(this.part)
console.log(this.customer)
    this.model.addressline1 = this.customer.data.addressline1
    this.model.addressline2 = this.customer.data.addressline2
    this.model.postalcode = this.customer.data.postalcode
    this.model.postaladdress = this.customer.data.postaladdress
    if (this.customer.data.deliveryAddress) {
      this.model.name = this.customer.data.deliveryAddress.name
      this.model.addressline1 = this.customer.data.deliveryAddress.addressline1
      this.model.addressline2 = this.customer.data.deliveryAddress.addressline2
      this.model.postalcode = this.customer.data.deliveryAddress.postalcode
      this.model.postaladdress = this.customer.data.deliveryAddress.postaladdress
    }
  }

  delete(index) {
    let count = 0
    this.products.splice(index, 1)
    this.products.forEach((line) => count += line.count)
    this.count = count
    this.countChange.emit(this.count)
    localStorage.setItem('cart', JSON.stringify(this.products))
  }

  total() {
    let sum = 0
    let count = 0
    this.products.map((p) => sum += p.data.set * p.data.price * p.count * (1 - p.Discount / 100))
    this.products.forEach((line) => count += line.count)
    this.count = count
    this.countChange.emit(this.count)
    return sum
  }

  send() {
    this.loading = true
    this.error = false
    console.log('-- send order --')
    this.order.post(this.part.service, this.products).subscribe((result: any) => {
      this.count = 0
      this.view = 'done'
      this.loading = false
      localStorage.removeItem('cart')
      this.countChange.emit(this.count)
      console.log('-- order result--')
      console.log(result)
    }, (error) => {
      this.loading = false
      console.log('-- order send failed --')
      this.error = true
    })
  }
}
